import { render, staticRenderFns } from "./SettingsDiscount.vue?vue&type=template&id=24705206&"
import script from "./SettingsDiscount.vue?vue&type=script&lang=js&"
export * from "./SettingsDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports